function getFocusableElements(container) {
  return Array.from(
    container.querySelectorAll(
      "summary, a[href], button:enabled, [tabindex]:not([tabindex^='-']), [draggable], area, input:not([type=hidden]):enabled, select:enabled, textarea:enabled, object, iframe"
    )
  );
}

document.querySelectorAll('[id^="Details-"] summary').forEach((summary) => {
  summary.setAttribute('role', 'button');
  summary.setAttribute('aria-expanded', 'false');

  if (summary.nextElementSibling.getAttribute('id')) {
    summary.setAttribute('aria-controls', summary.nextElementSibling.id);
  }

  summary.addEventListener('click', (event) => {
    event.currentTarget.setAttribute('aria-expanded', !event.currentTarget.closest('details').hasAttribute('open'));
  });

  if (summary.closest('header-drawer')) return;
  summary.parentElement.addEventListener('keyup', onKeyUpEscape);
});

const trapFocusHandlers = {};

function trapFocus(container, elementToFocus = container) {
  var elements = getFocusableElements(container);
  var first = elements[0];
  var last = elements[elements.length - 1];

  removeTrapFocus();

  trapFocusHandlers.focusin = (event) => {
    if (
      event.target !== container &&
      event.target !== last &&
      event.target !== first
    )
      return;

    document.addEventListener('keydown', trapFocusHandlers.keydown);
  };

  trapFocusHandlers.focusout = function () {
    document.removeEventListener('keydown', trapFocusHandlers.keydown);
  };

  trapFocusHandlers.keydown = function (event) {
    if (event.code.toUpperCase() !== 'TAB') return; // If not TAB key
    // On the last focusable element and tab forward, focus the first element.
    if (event.target === last && !event.shiftKey) {
      event.preventDefault();
      first.focus();
    }

    //  On the first focusable element and tab backward, focus the last element.
    if (
      (event.target === container || event.target === first) &&
      event.shiftKey
    ) {
      event.preventDefault();
      last.focus();
    }
  };

  document.addEventListener('focusout', trapFocusHandlers.focusout);
  document.addEventListener('focusin', trapFocusHandlers.focusin);

  elementToFocus.focus();
}

// Here run the querySelector to figure out if the browser supports :focus-visible or not and run code based on it.
try {
  document.querySelector(":focus-visible");
} catch (e) {
  focusVisiblePolyfill();
}

function focusVisiblePolyfill() {
  const navKeys = ['ARROWUP', 'ARROWDOWN', 'ARROWLEFT', 'ARROWRIGHT', 'TAB', 'ENTER', 'SPACE', 'ESCAPE', 'HOME', 'END', 'PAGEUP', 'PAGEDOWN']
  let currentFocusedElement = null;
  let mouseClick = null;

  window.addEventListener('keydown', (event) => {
    if (navKeys.includes(event.code.toUpperCase())) {
      mouseClick = false;
    }
  });

  window.addEventListener('mousedown', (event) => {
    mouseClick = true;
  });

  window.addEventListener('focus', () => {
    if (currentFocusedElement) currentFocusedElement.classList.remove('focused');

    if (mouseClick) return;

    currentFocusedElement = document.activeElement;
    currentFocusedElement.classList.add('focused');

  }, true);
}

function pauseAllMedia() {
  document.querySelectorAll('.js-youtube').forEach((video) => {
    video.contentWindow.postMessage('{"event":"command","func":"' + 'pauseVideo' + '","args":""}', '*');
  });
  document.querySelectorAll('.js-vimeo').forEach((video) => {
    video.contentWindow.postMessage('{"method":"pause"}', '*');
  });
  document.querySelectorAll('video').forEach((video) => video.pause());
  document.querySelectorAll('product-model').forEach((model) => {
    if (model.modelViewerUI) model.modelViewerUI.pause();
  });
}

function removeTrapFocus(elementToFocus = null) {
  document.removeEventListener('focusin', trapFocusHandlers.focusin);
  document.removeEventListener('focusout', trapFocusHandlers.focusout);
  document.removeEventListener('keydown', trapFocusHandlers.keydown);

  if (elementToFocus) elementToFocus.focus();
}

function onKeyUpEscape(event) {
  if (event.code.toUpperCase() !== 'ESCAPE') return;

  const openDetailsElement = event.target.closest('details[open]');
  if (!openDetailsElement) return;

  const summaryElement = openDetailsElement.querySelector('summary');
  openDetailsElement.removeAttribute('open');
  summaryElement.setAttribute('aria-expanded', false);
  summaryElement.focus();
}

class QuantityInput extends HTMLElement {
  constructor() {
    super();
    this.input = this.querySelector('input');
    this.changeEvent = new Event('change', { bubbles: true })

    this.querySelectorAll('button').forEach(
      (button) => button.addEventListener('click', this.onButtonClick.bind(this))
    );
  }

  onButtonClick(event) {
    event.preventDefault();
    const previousValue = this.input.value;

    event.target.name === 'plus' ? this.input.stepUp() : this.input.stepDown();
    if (previousValue !== this.input.value) this.input.dispatchEvent(this.changeEvent);
  }
}

customElements.define('quantity-input', QuantityInput);

function debounce(fn, wait) {
  let t;
  return (...args) => {
    clearTimeout(t);
    t = setTimeout(() => fn.apply(this, args), wait);
  };
}

function fetchConfig(type = 'json') {
  return {
    method: 'POST',
    headers: { 'Content-Type': 'application/json', 'Accept': `application/${type}` }
  };
}

/*
 * Shopify Common JS
 *
 */
if ((typeof window.Shopify) == 'undefined') {
  window.Shopify = {};
}

Shopify.bind = function (fn, scope) {
  return function () {
    return fn.apply(scope, arguments);
  }
};

Shopify.setSelectorByValue = function (selector, value) {
  for (var i = 0, count = selector.options.length; i < count; i++) {
    var option = selector.options[i];
    if (value == option.value || value == option.innerHTML) {
      selector.selectedIndex = i;
      return i;
    }
  }
};

Shopify.addListener = function (target, eventName, callback) {
  target.addEventListener ? target.addEventListener(eventName, callback, false) : target.attachEvent('on' + eventName, callback);
};

Shopify.postLink = function (path, options) {
  options = options || {};
  var method = options['method'] || 'post';
  var params = options['parameters'] || {};

  var form = document.createElement("form");
  form.setAttribute("method", method);
  form.setAttribute("action", path);

  for (var key in params) {
    var hiddenField = document.createElement("input");
    hiddenField.setAttribute("type", "hidden");
    hiddenField.setAttribute("name", key);
    hiddenField.setAttribute("value", params[key]);
    form.appendChild(hiddenField);
  }
  document.body.appendChild(form);
  form.submit();
  document.body.removeChild(form);
};

Shopify.CountryProvinceSelector = function (country_domid, province_domid, options) {
  this.countryEl = document.getElementById(country_domid);
  this.provinceEl = document.getElementById(province_domid);
  this.provinceContainer = document.getElementById(options['hideElement'] || province_domid);

  Shopify.addListener(this.countryEl, 'change', Shopify.bind(this.countryHandler, this));

  this.initCountry();
  this.initProvince();
};

Shopify.CountryProvinceSelector.prototype = {
  initCountry: function () {
    var value = this.countryEl.getAttribute('data-default');
    Shopify.setSelectorByValue(this.countryEl, value);
    this.countryHandler();
  },

  initProvince: function () {
    var value = this.provinceEl.getAttribute('data-default');
    if (value && this.provinceEl.options.length > 0) {
      Shopify.setSelectorByValue(this.provinceEl, value);
    }
  },

  countryHandler: function (e) {
    var opt = this.countryEl.options[this.countryEl.selectedIndex];
    var raw = opt.getAttribute('data-provinces');
    var provinces = JSON.parse(raw);

    this.clearOptions(this.provinceEl);
    if (provinces && provinces.length == 0) {
      this.provinceContainer.style.display = 'none';
    } else {
      for (var i = 0; i < provinces.length; i++) {
        var opt = document.createElement('option');
        opt.value = provinces[i][0];
        opt.innerHTML = provinces[i][1];
        this.provinceEl.appendChild(opt);
      }

      this.provinceContainer.style.display = "";
    }
  },

  clearOptions: function (selector) {
    while (selector.firstChild) {
      selector.removeChild(selector.firstChild);
    }
  },

  setOptions: function (selector, values) {
    for (var i = 0, count = values.length; i < values.length; i++) {
      var opt = document.createElement('option');
      opt.value = values[i];
      opt.innerHTML = values[i];
      selector.appendChild(opt);
    }
  }
};

class MenuDrawer extends HTMLElement {
  constructor() {
    super();

    this.mainDetailsToggle = this.querySelector('details');

    this.addEventListener('keyup', this.onKeyUp.bind(this));
    this.addEventListener('focusout', this.onFocusOut.bind(this));
    this.bindEvents();
  }

  bindEvents() {
    this.querySelectorAll('summary').forEach(summary => summary.addEventListener('click', this.onSummaryClick.bind(this)));
    this.querySelectorAll('button').forEach(button => { if (!button.classList.contains("disclosure__button")) button.addEventListener('click', this.onCloseButtonClick.bind(this)) });
  }

  onKeyUp(event) {
    if (event.code.toUpperCase() !== 'ESCAPE') return;

    const openDetailsElement = event.target.closest('details[open]');
    if (!openDetailsElement) return;

    openDetailsElement === this.mainDetailsToggle ? this.closeMenuDrawer(event, this.mainDetailsToggle.querySelector('summary')) : this.closeSubmenu(openDetailsElement);
  }

  onSummaryClick(event) {
    const summaryElement = event.currentTarget;
    const detailsElement = summaryElement.parentNode;
    const isOpen = detailsElement.hasAttribute('open');
    const reducedMotion = window.matchMedia("(prefers-reduced-motion: reduce)");

    function addTrapFocus() {
      trapFocus(summaryElement.nextElementSibling, detailsElement.querySelector('button'));
      summaryElement.nextElementSibling.removeEventListener('transitionend', addTrapFocus);
    }

    if (detailsElement === this.mainDetailsToggle) {
      if (isOpen) event.preventDefault();
      isOpen ? this.closeMenuDrawer(event, summaryElement) : this.openMenuDrawer(summaryElement);
    } else {
      setTimeout(() => {
        detailsElement.classList.add('menu-opening');
        summaryElement.setAttribute('aria-expanded', true);
        !reducedMotion || reducedMotion.matches ? addTrapFocus() : summaryElement.nextElementSibling.addEventListener('transitionend', addTrapFocus);
      }, 100);
    }
  }

  openMenuDrawer(summaryElement) {
    setTimeout(() => {
      this.mainDetailsToggle.classList.add('menu-opening');
    });
    summaryElement.setAttribute('aria-expanded', true);
    trapFocus(this.mainDetailsToggle, summaryElement);
    document.body.classList.add(`overflow-hidden-${this.dataset.breakpoint}`);

    const stickyHeader = document.querySelector('sticky-header');
    let viewportHeight = window.innerHeight;
    let headerBottomPosition = 0;
    if (stickyHeader) {
      headerBottomPosition = parseInt(document.getElementById("shopify-section-header").getBoundingClientRect().bottom);
    } else {
      headerBottomPosition = -5; // offset CSS value
    }
    document.documentElement.style.setProperty('--viewport-height', `${viewportHeight}px`);
    document.documentElement.style.setProperty('--header-bottom-position', `${headerBottomPosition}px`);
  }

  closeMenuDrawer(event, elementToFocus = false) {
    if (event === undefined) return;

    this.mainDetailsToggle.classList.remove('menu-opening');
    this.mainDetailsToggle.querySelectorAll('details').forEach(details => {
      details.removeAttribute('open');
      details.classList.remove('menu-opening');
    });
    document.body.classList.remove(`overflow-hidden-${this.dataset.breakpoint}`);
    removeTrapFocus(elementToFocus);
    this.closeAnimation(this.mainDetailsToggle);
  }

  onFocusOut(event) {
    setTimeout(() => {
      if (this.mainDetailsToggle.hasAttribute('open') && !this.mainDetailsToggle.contains(document.activeElement)) this.closeMenuDrawer();
    });
  }

  onCloseButtonClick(event) {
    const detailsElement = event.currentTarget.closest('details');
    this.closeSubmenu(detailsElement);
  }

  closeSubmenu(detailsElement) {
    detailsElement.classList.remove('menu-opening');
    detailsElement.querySelector('summary').setAttribute('aria-expanded', false);
    removeTrapFocus(detailsElement.querySelector('summary'));
    this.closeAnimation(detailsElement);
  }

  closeAnimation(detailsElement) {
    let animationStart;

    const handleAnimation = (time) => {
      if (animationStart === undefined) {
        animationStart = time;
      }

      const elapsedTime = time - animationStart;

      if (elapsedTime < 400) {
        window.requestAnimationFrame(handleAnimation);
      } else {
        detailsElement.removeAttribute('open');
        if (detailsElement.closest('details[open]')) {
          trapFocus(detailsElement.closest('details[open]'), detailsElement.querySelector('summary'));
        }
      }
    }

    window.requestAnimationFrame(handleAnimation);
  }
}

customElements.define('menu-drawer', MenuDrawer);

class HeaderDrawer extends MenuDrawer {
  constructor() {
    super();
  }

  openMenuDrawer(summaryElement) {
    this.header = this.header || document.getElementById('shopify-section-header');
    this.borderOffset = this.borderOffset || this.closest('.header-wrapper').classList.contains('header-wrapper--border-bottom') ? 1 : 0;

    document.documentElement.style.setProperty('--viewport-height', `${window.innerHeight}px`);
    document.documentElement.style.setProperty('--header-bottom-position', `${parseInt(this.getBoundingClientRect().bottom - this.borderOffset)}px`);
    this.header.classList.add('menu-open');

    setTimeout(() => {
      this.mainDetailsToggle.classList.add('menu-opening');
    });

    summaryElement.setAttribute('aria-expanded', true);
    trapFocus(this.mainDetailsToggle, summaryElement);
    document.body.classList.add(`overflow-hidden-${this.dataset.breakpoint}`);
  }

  closeMenuDrawer(event, elementToFocus) {
    super.closeMenuDrawer(event, elementToFocus);
    this.header.classList.remove('menu-open');
  }
}

customElements.define('header-drawer', HeaderDrawer);

class ProductModal extends HTMLElement {
  constructor() {
    super();
    this.querySelector('[id^="ModalClose-"]').addEventListener(
      'click',
      this.hide.bind(this)
    );
    this.addEventListener('keyup', (event) => {
      if (event.code.toUpperCase() === 'ESCAPE') this.hide();
    });
    if (this.classList.contains('media-modal')) {
      this.addEventListener('pointerup', (event) => {
        if (event.pointerType === 'mouse' && !event.target.closest('deferred-media, product-model')) this.hide();
      });
    }
  }

  connectedCallback() {
    if (this.moved) return;
    this.moved = true;
    document.body.appendChild(this);
  }

  show(popupContent, opener) {
    this.openedBy = opener;
    let contentToAdd = popupContent.querySelector('video, model-viewer, iframe');
    if (contentToAdd.nodeName === 'MODEL-VIEWER') {
      contentToAdd.poster = ""; // avoid flickering poster image on mobile modal
    }
    this.querySelector(".product-popup-modal__content-info").appendChild(contentToAdd);
    if (focus) this.focus();

    document.body.classList.add('overflow-hidden');
    this.setAttribute('open', '');
    trapFocus(this, this);
  }

  hide() {
    const modalInner = this.querySelector(".product-popup-modal__content-info").querySelector('video, model-viewer, iframe');
    this.openedBy.appendChild(modalInner);
    document.body.classList.remove('overflow-hidden');
    this.removeAttribute('open');
    removeTrapFocus(this);
    window.pauseAllMedia();
  }
}
customElements.define('product-modal', ProductModal);

class DeferredMedia extends HTMLElement {
  constructor() {
    super();
    const poster = this.querySelector('[id^="Deferred-Poster-"]');
    if (!poster) return;
    poster.addEventListener('click', this.loadContent.bind(this));
  }

  loadContent(focus = true) {
    // Non-image media is added to a modal on mobile
    if (window.matchMedia("(max-width: 990px)").matches && !this.classList.contains("no-modal")) {
      const content = document.createElement('div');
      content.appendChild(this.querySelector('template').content.firstElementChild);
      const productModal = document.querySelector("product-modal");
      productModal.show(content, this.querySelector('template').content);
    } else {
      window.pauseAllMedia();
      if (!this.getAttribute('loaded')) {
        const content = document.createElement('div');
        content.appendChild(this.querySelector('template').content.firstElementChild.cloneNode(true));

        this.setAttribute('loaded', true);
        const deferredElement = this.appendChild(content.querySelector('video, model-viewer, iframe'));
        if (focus) deferredElement.focus();
      }
    }
  }
}

customElements.define('deferred-media', DeferredMedia);

class VariantSelects extends HTMLElement {
  constructor() {
    super();
    this.addEventListener('change', this.onVariantChange);
  }

  getVariantMediaMap() {
    // Get the variant media mapping from the JSON script tag
    if (!this.variantMediaMap) {
      const script = document.querySelector(`script[data-section-id="${this.dataset.section}"]`);
      if (script) {
        try {
          this.variantMediaMap = JSON.parse(script.textContent);
        } catch (e) {
          console.error('Error parsing variant media map:', e);
          this.variantMediaMap = {};
        }
      } else {
        this.variantMediaMap = {};
      }
    }
    return this.variantMediaMap;
  }

  updatePriceAndStock(html, sectionId) {
    // Shared method to update price and low stock displays from fetched HTML
    const idPrice = `price-${sectionId}`;
    const idLowStock = `lowStock-${sectionId}`;
    const destinationPrice = document.getElementById(idPrice);
    const destinationLowStock = document.getElementById(idLowStock);
    const sourcePrice = html.getElementById(idPrice);
    const sourceLowStock = html.getElementById(idLowStock);

    if (sourcePrice && destinationPrice) destinationPrice.innerHTML = sourcePrice.innerHTML;
    if (sourceLowStock && destinationLowStock) destinationLowStock.innerHTML = sourceLowStock.innerHTML;
  }

  onVariantChange() {
    this.updateOptions().then(() => {
      this.updatePickupAvailability();
      this.removeErrorMessage();

      if (!this.currentVariant) {
        this.toggleAddButton(true, '', true);
      } else {
        // updateMedia() is called in updateOptions() after getting featured_media from hidden input
        this.updateURL();
        this.updateVariantInput();
        this.renderProductInfo();
      }
    });
  }

  updateOptions() {
    const sectionId = this.dataset.section;
    const productUrl = this.dataset.url;

    // Get button and spinner references
    const addButton = document.querySelector(`#product-form-${sectionId} [name="add"]`);
    const spinner = document.querySelector(`#product-form-${sectionId} .loading-overlay__spinner`);

    // Get the selected option value IDs and format as query param
    const selectedOptionValues = Array.from(this.querySelectorAll('select')).map((select) => {
      const selectedOption = select.options[select.selectedIndex];
      return selectedOption.dataset.optionValueId;
    }).filter(id => id); // Filter out any undefined values
    const params = selectedOptionValues.length > 0
      ? `&option_values=${selectedOptionValues.join(',')}`
      : '';

    // Deferred variants: Fetch the option value picker with the new availability state when remaining on the same product
    return fetch(`${productUrl}?section_id=${sectionId}${params}`)
      .then((response) => response.text())
      .then((responseText) => {
        const html = new DOMParser().parseFromString(responseText, 'text/html');

        const newData = html.querySelector('.main-product__option-value-selectors');
        if (newData) {
          const id = newData.id;
          const toUpdate = document.getElementById(id);
          if (toUpdate) {
            toUpdate.innerHTML = newData.innerHTML;
          }
        }

        // Extract current variant info from the response
        const hiddenInput = html.querySelector('input[name="id"]');
        const addButton = html.querySelector('[name="add"]');

        if (hiddenInput && hiddenInput.value && hiddenInput.value !== '') {
          // Create variant object with the info we need
          this.currentVariant = {
            id: hiddenInput.value,
            available: addButton && !addButton.hasAttribute('disabled')
          };

          // Get featured_media ID from the variant media map
          const variantMediaMap = this.getVariantMediaMap();
          const variantData = variantMediaMap[this.currentVariant.id];

          if (variantData && variantData.featured_media_id) {
            this.currentVariant.featured_media = {
              id: variantData.featured_media_id
            };
          }

          // Update media after we have variant data
          this.updateMedia();

          // Update price and low stock from this response (avoids second fetch)
          this.updatePriceAndStock(html, sectionId);
        } else {
          this.currentVariant = null;
        }

        // Clear loading state
        if (addButton) {
          addButton.classList.remove('loading');
        }
        if (spinner) {
          spinner.classList.add('hidden');
        }

      });
  }

  updateMedia() {
    if (!this.currentVariant) return;
    if (!this.currentVariant.featured_media) return;

    const mediaSlideId = `[data-media-id="${this.dataset.section}-${this.currentVariant.featured_media.id}"]`;
    const mediaSlide = document.querySelector(mediaSlideId);

    if (!mediaSlide) return;

    let isSlider = false;
    const bMobile = window.matchMedia("(max-width: 749px)").matches;

    // check if the current desktop layout is a slider
    const sectionId = this.dataset.section;
    const swiperElement = document.getElementById(`swiper-${sectionId}`);

    if (!swiperElement) return;

    const numSlides = swiperElement.children[0].children.length;
    const bSlider = swiperElement.dataset.desktopLayout === "slider";

    if (bMobile || bSlider) {
      if (numSlides > 1) {
        isSlider = true;
      }
    }

    if (isSlider) {
      const mediaSlideIndex = mediaSlide.dataset.slideIndex;
      // Get swiper instance - use the swiperElement we already found or find via closest()
      const swiperInstance = swiperElement.swiper || mediaSlide.closest('.swiper')?.swiper;
      if (swiperInstance) {
        swiperInstance.slideTo(mediaSlideIndex);
      }
    } else if (!bSlider && numSlides > 1 && !bMobile) {
      // If not a slider, scroll to the media slide (stacked layout)
      let yHeaderOffset = 0;
      const stickyHeader = document.querySelector('sticky-header')
      if (stickyHeader) {
        yHeaderOffset = stickyHeader.offsetHeight;
      }
      const scrollPosition = mediaSlide.getBoundingClientRect().top + window.pageYOffset - yHeaderOffset;

      window.scrollTo({ top: scrollPosition, behavior: 'smooth' });
    }
  }

  updateURL() {
    if (!this.currentVariant || this.dataset.updateUrl === 'false') return;
    window.history.replaceState({}, '', `${this.dataset.url}?variant=${this.currentVariant.id}`);
  }

  updateVariantInput() {
    const productForms = document.querySelectorAll(`#product-form-${this.dataset.section}, #product-form-installment`);
    productForms.forEach((productForm) => {
      const input = productForm.querySelector('input[name="id"]');
      input.value = this.currentVariant.id;
      input.dispatchEvent(new Event('change', { bubbles: true }));
    });
  }

  updatePickupAvailability() {
    const pickUpAvailability = document.querySelector('pickup-availability');
    if (!pickUpAvailability) return;

    if (this.currentVariant && this.currentVariant.available) {
      pickUpAvailability.fetchAvailability(this.currentVariant.id);
    } else {
      pickUpAvailability.removeAttribute('available');
      pickUpAvailability.innerHTML = '';
    }
  }

  removeErrorMessage() {
    const section = this.closest('section');
    if (!section) return;

    const productForm = section.querySelector('product-form');
    if (productForm && typeof productForm.handleErrorMessage === 'function') {
      productForm.handleErrorMessage();
    }
  }

  renderProductInfo() {
    // Price and low stock are now updated in updateOptions() to avoid duplicate fetch
    // Just update UI state here
    const price = document.getElementById(`price-${this.dataset.section}`);
    if (price) price.classList.remove('visibility-hidden');
    this.toggleAddButton(!this.currentVariant.available, window.variantStrings.soldOut);
  }

  toggleAddButton(disable = true, text, modifyClass = true) {
    const productForm = document.getElementById(`product-form-${this.dataset.section}`);
    if (!productForm) return;
    const addButton = productForm.querySelector('[name="add"]');
    const addButtonText = productForm.querySelector('[name="add"] > span');

    if (!addButton) return;

    if (disable) {
      addButton.setAttribute('disabled', 'disabled');
      if (text) addButtonText.textContent = text;
    } else {
      addButton.removeAttribute('disabled');
      addButtonText.textContent = window.variantStrings.addToCart;
    }

    if (!modifyClass) return;
  }
}

customElements.define('variant-selects', VariantSelects);

class VariantRadios extends VariantSelects {
  constructor() {
    super();
  }

  updateOptions() {
    const sectionId = this.dataset.section;
    const productUrl = this.dataset.url;

    // Update visual state for radio buttons
    const labels = this.querySelectorAll("label");
    labels.forEach((label) => {
      label.classList.remove('bg-accent', 'color-swatches__swatch--active');
      label.classList.add('bg-default');
    });

    const fieldsets = Array.from(this.querySelectorAll('fieldset'));
    fieldsets.forEach((fieldset) => {
      const selectedInput = Array.from(fieldset.querySelectorAll('input')).find((radio) => radio.checked);
      if (selectedInput) {
        const selectedLabel = selectedInput.nextElementSibling;
        selectedLabel.classList.remove('bg-default');
        selectedLabel.classList.add('bg-accent', 'color-swatches__swatch--active');

        // Update the selected value text in the legend
        const valueSpan = fieldset.querySelector('legend span');
        if (valueSpan) {
          valueSpan.textContent = selectedInput.value;
        }
      }
    });

    // Get the selected option value IDs for section render API
    const selectedOptionValues = fieldsets.map((fieldset) => {
      const selectedInput = Array.from(fieldset.querySelectorAll('input')).find((radio) => radio.checked);
      return selectedInput ? selectedInput.dataset.optionValueId : null;
    }).filter(id => id);

    const params = selectedOptionValues.length > 0
      ? `&option_values=${selectedOptionValues.join(',')}`
      : '';

    // Use section render API to get updated variant state
    return fetch(`${productUrl}?section_id=${sectionId}${params}`)
      .then((response) => response.text())
      .then((responseText) => {
        const html = new DOMParser().parseFromString(responseText, 'text/html');

        // Extract current variant info from the response
        const hiddenInput = html.querySelector('input[name="id"]');
        const addButton = html.querySelector('[name="add"]');

        if (hiddenInput && hiddenInput.value && hiddenInput.value !== '') {
          this.currentVariant = {
            id: hiddenInput.value,
            available: addButton && !addButton.hasAttribute('disabled')
          };

          // Get featured_media ID from the variant media map
          const variantMediaMap = this.getVariantMediaMap();
          const variantData = variantMediaMap[this.currentVariant.id];

          if (variantData && variantData.featured_media_id) {
            this.currentVariant.featured_media = {
              id: variantData.featured_media_id
            };
          }

          // Update media after we have variant data
          this.updateMedia();

          // Update price and low stock from this response (avoids second fetch)
          this.updatePriceAndStock(html, sectionId);
        } else {
          this.currentVariant = null;
        }
      });
  }
}

customElements.define('variant-radios', VariantRadios);

class ProductRecommendations extends HTMLElement {
  constructor() {
    super();

    const handleIntersection = (entries, observer) => {
      if (!entries[0].isIntersecting) return;
      observer.unobserve(this);

      fetch(this.dataset.url)
        .then(response => response.text())
        .then(text => {
          const html = document.createElement('div');
          html.innerHTML = text;
          const recommendations = html.querySelector('product-recommendations');

          if (recommendations && recommendations.innerHTML.trim().length) {
            this.innerHTML = recommendations.innerHTML;
          }

          if (html.querySelector('.grid__item')) {
            this.classList.add('product-recommendations--loaded');
          }
        })
        .catch(e => {
          console.error(e);
        });
    }

    new IntersectionObserver(handleIntersection.bind(this), { rootMargin: '0px 0px 200px 0px' }).observe(this);
  }
}

customElements.define('product-recommendations', ProductRecommendations);

class CountdownTimer extends HTMLElement {
  constructor() {
    super();
  }
  connectedCallback() {
    const date = this.getAttribute("data-countdown-date");
    const showCompletionMessage = this.getAttribute("data-countdown-complete");
    const completionMessage = this.getAttribute("data-countdown-complete-message");
    const countDownDate = new Date(date).getTime();

    const updateCountdown = function (countdownElement) {
      const currentTime = new Date().getTime();
      const timeDifference = countDownDate - currentTime;

      let days = 0;
      let hours = 0;
      let minutes = 0;
      let seconds = 0;

      if (timeDifference < 0 && showCompletionMessage === "true") {
        clearInterval(updateCountdown);
        countdownElement.innerHTML = `<div class="countdown__complete-message h3">${completionMessage}</div>`;
      } else {
        if (timeDifference > 0) {
          days = Math.floor(timeDifference / (1000 * 60 * 60 * 24));
          hours = Math.floor((timeDifference % (1000 * 60 * 60 * 24)) / (1000 * 60 * 60));
          minutes = Math.floor((timeDifference % (1000 * 60 * 60)) / (1000 * 60));
          seconds = Math.floor((timeDifference % (1000 * 60)) / 1000);
        }
        // Update only the timer numbers, preserving the HTML structure and styles
        const daysTimer = countdownElement.querySelector('#countdownDays .countdown__clock-timer');
        const hoursTimer = countdownElement.querySelector('#countdownHours .countdown__clock-timer');
        const minutesTimer = countdownElement.querySelector('#countdownMinutes .countdown__clock-timer');
        const secondsTimer = countdownElement.querySelector('#countdownSeconds .countdown__clock-timer');

        if (daysTimer) daysTimer.textContent = days;
        if (hoursTimer) hoursTimer.textContent = hours;
        if (minutesTimer) minutesTimer.textContent = minutes;
        if (secondsTimer) secondsTimer.textContent = seconds;
      }
    }
    setInterval(updateCountdown, 1000, this);
  }
}

customElements.define('countdown-timer', CountdownTimer);